import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Translate from "../../utils/Translate";
import { DatePicker } from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import { useApi } from "../../utils/Api";
import { formatDate } from "../../utils/dateTimeFormat";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { getCurrentDateMask, getCurrentInputFormat } from "../../utils/dateTimeFormat";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ButtonWithSpinner from "../ButtonWithSpinner";
import { Stack } from "@mui/material";
import { accessKeys, hasSomeAccess } from "../../utils/userAccess";
const Comp = (props) => {
  useEffect(() => {
    window.analyticsEvent("eport_xtras", "eport_publish_online");
  }, []);

  //console.log('props', props);
  //----------Finns alltid med
  const api = useApi();
  const location = useLocation();
  const navigate = useNavigate();
  const closeAndReload = () => {
    //Soft reload with redirect
    const loc = encodeURIComponent(location.pathname);
    navigate(`/redirect/${loc}`, { replace: true });
  };
  //----------
  const dTime = new Date();
  const now = new Date(Date.UTC(dTime.getUTCFullYear(), dTime.getUTCMonth(), dTime.getUTCDate()));
  const [startDate, setStartDate] = useState(props.publishFromDate || now);
  const [endDate, setEndDate] = useState(props.publishToDate || props.fromDate);
  const [data, setData] = useState(false);
  const [autoUnpublishWhenFull, setAutoUnpublishWhenFull] = useState(!!props.autoUnpublishWhenFull);

  function calculateEndDate(startDate, courseDays) {
    let endDate = addDays(startDate, courseDays);
    return endDate;
  }
  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
  const fromToDateCheck = (from, to) => {
    from = Date.parse(from);
    to = Date.parse(to);
    if (isNaN(from) || isNaN(to)) {
      return false;
    } else if (to < from) {
      return false;
    } else {
      return true;
    }
  };

  async function unpublishFromWeb() {
    const url = `${import.meta.env.VITE_MAIN_URL}courses/${props.courseId}/unpublish`;
    const data = await api.fetch(url);
    setData(data);
    closeAndReload();
  }

  async function publishToWeb() {
    const url = `${import.meta.env.VITE_MAIN_URL}courses/${props.courseId}/publish/${formatDate(
      startDate,
      "sv-SE",
    )}/${formatDate(endDate, "sv-SE")}?autoUnpublishWhenFull=${autoUnpublishWhenFull}`;
    const data = await api.fetch(url);
    setData(data);
    closeAndReload();
  }

  return (
    <>
      <DialogTitle>
        <div className="stdFlexBetween">
          <div>{Translate.get("ePort2iFramePublishOnline")}</div>
          <Tooltip title={Translate.get("ePort2iFramePublishTooltip")}>
            <IconButton>
              <InfoIcon color="primary" />
            </IconButton>
          </Tooltip>
        </div>
      </DialogTitle>
      <DialogContent dividers={true} className="stdDialogContent">
        <Stack direction="column" gap={3} marginTop={1} marginBottom={1}>
          <Stack direction="row" alignItems="center" justifyContent="stretch" gap={1}>
            <CalendarTodayIcon />
            <DatePicker
              displayWeekNumber={hasSomeAccess(accessKeys.swedishCompany, accessKeys.isMASystem)}
              sx={{ flexGrow: 1 }}
              format={getCurrentInputFormat()}
              mask={getCurrentDateMask()}
              label={Translate.get("StartDate")}
              value={startDate ? new Date(startDate) : null}
              onChange={(newValue) => {
                setStartDate(newValue);
                //const newEndDate = calculateEndDate(newValue, 7);
                //setEndDate(newEndDate);
                //updateFormData("endDate", newEndDate);
                //updateFormData("startDate", newValue);
              }}
              slotProps={{ textField: { fullWidth: true, required: true } }}
            />
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="stretch" gap={1}>
            <CalendarTodayIcon />
            <DatePicker
              displayWeekNumber={hasSomeAccess(accessKeys.swedishCompany, accessKeys.isMASystem)}
              sx={{ flexGrow: 1 }}
              format={getCurrentInputFormat()}
              mask={getCurrentDateMask()}
              label={Translate.get("EndDate")}
              value={endDate ? new Date(endDate) : null}
              onChange={(newValue) => {
                setEndDate(newValue);
                //updateFormData("endDate", newValue);
              }}
              slotProps={{ textField: { fullWidth: true, required: true } }}
            />
          </Stack>
          <FormControlLabel
            control={
              <Checkbox checked={autoUnpublishWhenFull} onChange={(e) => setAutoUnpublishWhenFull(e.target.checked)} />
            }
            label={Translate.get("AutoUnpublishWhenFullDescription")}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => window.history.back()}>{Translate.get("Cancel")}</Button>
        {!!props.publishFromDate && (
          <ButtonWithSpinner variant="outlined" color="error" className="stdLightLoader" onClick={unpublishFromWeb}>
            {Translate.get("ePort2iFrameUnpublish")}
          </ButtonWithSpinner>
        )}
        <ButtonWithSpinner
          variant="contained"
          className="stdLightLoader"
          disabled={!fromToDateCheck(startDate, endDate)}
          onClick={publishToWeb}
        >
          {Translate.get("ePort2iFramePublish")}
        </ButtonWithSpinner>
      </DialogActions>
    </>
  );
};
export default Comp;
